<template>
  <div
    v-if="shouldFavIconShow"
    class="i-favorite"
  >
    <slot
      v-if="$scopedSlots.default"
      :is-active="isActive"
      :title="title"
      :on-click="favoriteHandler"
    />
    <template v-else>
      <div
        class="star-btn"
        :class="{ small, animate: clicked, active: isActive }"
        :title="title"
        @click="favoriteHandler"
      >
        <i class="isif isif-star back" />
        <i class="isif isif-star front" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { MODALS } from '@/components/VrLounge'

export default {
  name: 'IFavorite',
  props: {
    category: {
      type: String, // store.favorites.acceptedCategories
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    clicked: false,
    inCooldown: false,
    timeout: null
  }),
  computed: {
    ...mapState('favorites', [
      'data'
    ]),
    ...mapGetters([
      'visitorHasPass',
      'currentBuilding'
    ]),
    ...mapGetters([
      'user'
    ]),
    ...mapGetters('favorites', [
      'enabled'
    ]),
    ...mapGetters('auth', [
      'isLogin'
    ]),
    id () {
      return this.item.objectId
    },
    isActive () {
      const isPano = this.category === 'panorama'
      const realCategory = isPano
        ? 'user'
        : this.category
      let base = this.data[realCategory + 's']
      if (base) {
        if (isPano) {
          base = base.find(user => user.id === this.user.objectId) || {}
        }
        const stack = isPano ? base.panoramas : base
        return (stack || []).filter(item => item.id === this.id).length > 0
      }
      return false
    },
    title () {
      return this.isActive ? this.$t('favorites.remove') : this.$t('favorites.add')
    },
    shouldFavIconShow () {
      if (this.currentBuilding) {
        const { requireVisitorData, requireWhiteListing } = this.currentBuilding
        const notRequireVisitorValidation = !requireVisitorData && !requireWhiteListing
        const passValidation = this.visitorHasPass || notRequireVisitorValidation
        if (this.enabled && passValidation) {
          return true
        }
      }
      return false
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
  },
  methods: {
    ...mapActions('favorites', [
      'add',
      'remove'
    ]),
    ...mapActions('vrlounge', [
      'setCurrentModal'
    ]),
    favoriteHandler () {
      if (!this.isLogin) {
        this.setCurrentModal(MODALS.login)
        return
      }
      this.clicked = true
      if (this.inCooldown) {
        return
      }
      if (this.isActive) {
        this.remove({
          category: this.category,
          id: this.id
        })
      } else {
        this.add({
          category: this.category,
          id: this.id
        })
      }
      this.setCooldown()
    },
    setCooldown () {
      this.inCooldown = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.inCooldown = false
      }, 1000)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/common/main'
$size = 30px
$size-small = 26px

.star-btn {
  width: $size
  height: $size
  text-align: center
  position: relative
  display: flex
  justify-content: center
  align-items: center
  cursor: pointer

  &:after {
    $size = 50px
    $half-size = $size / 2

    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -($half-size);
    margin-left: -($half-size);
    width: $size;
    height: $size;
    opacity: 0;
    box-shadow: inset 0 0 0 $half-size rgba($yellow, 0);
    border-radius: 50%;
    pointer-events: none;
  }
  &.animate.active:after {
    animation: fav-animate .5s ease-out forwards;
  }
  &.small {
    width: $size-small
    height: $size-small
  }
}
@keyframes fav-animate {
  0% {
    opacity: 1;
    transform: scale3d(0.4, 0.4, 1);
  }
  80% {
    opacity: 0.1;
    box-shadow: inset 0 0 0 2px rgba($yellow, .8);
  }
  100% {
    opacity: 0;
    box-shadow: inset 0 0 0 2px rgba($yellow, .8);
    transform: scale3d(1.2, 1.2, 1);
  }
}
i {
  font-size: $size - 6px
  color: #C7C7C7
  position: absolute
  transition: .2s

  .small > & {
    font-size: $size-small - 6px
  }
  .active > &.front {
    color: $yellow
    background: -webkit-linear-gradient(#fff176, #f9a825)
    -webkit-background-clip: text
    background-clip: text
    -webkit-text-fill-color: transparent
    text-fill-color: transparent
  }
  &.back {
    font-size: $size
    color: #444
    opacity: .5

    .small > & {
      font-size: $size-small
    }
  }
  .active > &.back {
    opacity: 1
  }
}
</style>
